import { useState, useEffect } from 'react';
import axios from 'axios'
import geolocations from '../data/mastermind-attendance-geoLocation.json';

const AttendanceGeoLocations = ({ event_id, attendanceData }) => {
  const [loadingGeoLocations, setLoadingGeoLocations] = useState(true);
  const [geoLocations, setGeoLocations] = useState([]);

  useEffect(() => {
    if (attendanceData.length == 0 || attendanceData.attendance.length == 0) {
      return
    }
    if (event_id == 8931) {
      const validResults = geolocations.filter((result) =>
        attendanceData.attendance.some(
          (attendee) => attendee.ip_address && attendee.ip_address === result.ip
        )
      );
      const combinedGeoData = combineGeoData(validResults);
      setGeoLocations(combinedGeoData);
      setLoadingGeoLocations(false);
    } else {
      // lookupGeoLocations();
      setLoadingGeoLocations(false);
    }
  }, [attendanceData]);

  const fetchGeolocation = async (ip) => {
    const url = `https://ipgeolocation.abstractapi.com/v1/?api_key=${process.env.REACT_APP_ABSTRACT_API_KEY}&ip_address=${encodeURIComponent(ip)}`;
    try {
      const response = await axios.get(url);
      return {
        ip,
        city: response.data.city || 'N/A',
        region: response.data.region || 'N/A',
        country: response.data.country || 'N/A',
        latitude: response.data.latitude || 'N/A',
        longitude: response.data.longitude || 'N/A',
      };
    } catch (err) {
      return { ip, error: `Failed to fetch data for ${ip}` };
    }
  };
  const lookupGeoLocations = async () => {
    setLoadingGeoLocations(true);
    const validResults = [];
    for (const attendee of attendanceData.attendance) {
      if (!attendee.ip_address) continue; // skip
      const result = await fetchGeolocation(attendee.ip_address);
      if (!result.error) validResults.push(result);
      await new Promise((resolve) => setTimeout(resolve, 1000));
    }
    setGeoLocations(validResults);
    // Output results as JSON to console for saving to a file
    console.log('GeoLocation Results JSON:');
    console.log(JSON.stringify(validResults, null, 2));
    setLoadingGeoLocations(false);
  };
  function combineGeoData(data) {
    const map = new Map();
    // Loop through the data
    data.forEach(item => {
      const key = `${item.city}-${item.region}`;
      if (map.has(key)) {
        // Increment count for existing city-region combination
        const existing = map.get(key);
        existing.count += 1;
        // Optionally, you can keep track of IPs or other properties if needed
        existing.ips = existing.ips || [];
        existing.ips.push(item.ip);
      } else {
        // Create new entry with count 1
        const newEntry = {
          ...item,
          count: 1,
          ips: [item.ip] // Optionally store IPs
        };
        map.set(key, newEntry);
      }
    });
    // Convert map values to array and sort by count in descending order
    const result = Array.from(map.values()).sort((a, b) => b.count - a.count);
    return result;
  }

  return (
    <div>
      {(!loadingGeoLocations && geoLocations.length > 0) ? (
        <ul className="attendance-locations">
          {geoLocations.map((geoLocation, key) => {
            return (
              <li className="attendance-location" key={key}>
                <span>{geoLocation.city}, {geoLocation.region}</span>
                <span>{geoLocation.count}</span>
              </li>
            );
          })}
        </ul>
      ) : (
        <p>Attendance geo locations data goes here.</p>
      )}
    </div>
  );
};

export default AttendanceGeoLocations;